import React, { useState } from 'react';
import apiClient from '../api/apiClient';

export default function LocationsPage({ locations, onSelectLocation, loading, onRefresh }) {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', pin: '', description: '' });
  const [isCreating, setIsCreating] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const handleCreateLocation = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.pin) {
      alert('Nombre y PIN son requeridos');
      return;
    }

    setIsCreating(true);
    const result = await apiClient.createLocation(
      formData.name,
      formData.pin,
      formData.description
    );
    setIsCreating(false);

    if (result.success) {
      alert('Ubicación creada exitosamente');
      setFormData({ name: '', pin: '', description: '' });
      setShowModal(false);
      onRefresh();
    } else {
      alert(`Error: ${result.error}`);
    }
  };

  const handleDeleteLocation = async (location) => {
    const ok = window.confirm(
      '¿Eliminar la ubicación "' + location.name + '"?\n\n' +
      'Se borrarán TODOS sus archivos del servidor y dejará de monitorearse.\n' +
      'Esta acción no se puede deshacer.'
    );
    if (!ok) return;

    setDeletingId(location.id);
    const result = await apiClient.deleteLocation(location.id);
    setDeletingId(null);

    if (result.success) {
      onRefresh();
    } else {
      alert(`Error: ${result.error}`);
    }
  };

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'2rem'}}>
        <h2 style={{color:'#1e3c72'}}>📁 Mis Ubicaciones ({locations.length})</h2>
        <button
          onClick={() => setShowModal(true)}
          style={{background:'#28a745',color:'white',padding:'0.7rem 1.5rem',border:'none',borderRadius:'4px',cursor:'pointer',fontWeight:'600'}}
        >
          + Nueva Ubicación
        </button>
      </div>

      {locations.length === 0 ? (
        <p>No hay ubicaciones</p>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))',gap:'1.5rem'}}>
          {locations.map((location) => (
            <div key={location.id} style={{background:'white',border:'1px solid #e9ecef',borderRadius:'8px',padding:'1.5rem',boxShadow:'0 2px 8px rgba(0, 0, 0, 0.05)'}}>
              <h3 style={{color:'#1e3c72',marginBottom:'0.5rem'}}>📍 {location.name}</h3>
              {location.description && <p style={{color:'#6c757d',fontSize:'0.9rem',marginBottom:'1rem'}}>{location.description}</p>}
              <button
                onClick={() => onSelectLocation(location)}
                disabled={loading}
                style={{width:'100%',padding:'0.7rem',background:'#2a5298',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',marginBottom:'0.6rem'}}
              >
                Ver Archivos →
              </button>
              <button
                onClick={() => handleDeleteLocation(location)}
                disabled={loading || deletingId === location.id}
                style={{width:'100%',padding:'0.6rem',background:'white',color:'#dc3545',border:'1px solid #dc3545',borderRadius:'4px',cursor:'pointer',fontWeight:'600'}}
              >
                {deletingId === location.id ? 'Eliminando...' : '🗑️ Eliminar ubicación'}
              </button>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'white',padding:'2rem',borderRadius:'8px',maxWidth:'400px',width:'90%',boxShadow:'0 10px 40px rgba(0,0,0,0.2)'}}>
            <h3 style={{color:'#1e3c72',marginBottom:'1.5rem'}}>+ Nueva Ubicación</h3>
            <form onSubmit={handleCreateLocation}>
              <div style={{marginBottom:'1rem'}}>
                <label style={{display:'block',marginBottom:'0.5rem',color:'#495057',fontWeight:'600'}}>Nombre</label>
                <input
                  type="text"
                  placeholder="Ej: Guadalajara"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  style={{width:'100%',padding:'0.8rem',border:'1px solid #dee2e6',borderRadius:'4px',fontSize:'1rem'}}
                  disabled={isCreating}
                />
              </div>

              <div style={{marginBottom:'1rem'}}>
                <label style={{display:'block',marginBottom:'0.5rem',color:'#495057',fontWeight:'600'}}>PIN</label>
                <input
                  type="text"
                  placeholder="Ej: 1234"
                  maxLength="6"
                  value={formData.pin}
                  onChange={(e) => setFormData({...formData, pin: e.target.value})}
                  style={{width:'100%',padding:'0.8rem',border:'1px solid #dee2e6',borderRadius:'4px',fontSize:'1rem'}}
                  disabled={isCreating}
                />
              </div>

              <div style={{marginBottom:'1.5rem'}}>
                <label style={{display:'block',marginBottom:'0.5rem',color:'#495057',fontWeight:'600'}}>Descripción</label>
                <input
                  type="text"
                  placeholder="Ej: Sucursal Guadalajara"
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  style={{width:'100%',padding:'0.8rem',border:'1px solid #dee2e6',borderRadius:'4px',fontSize:'1rem'}}
                  disabled={isCreating}
                />
              </div>

              <div style={{display:'flex',gap:'1rem'}}>
                <button
                  type="submit"
                  disabled={isCreating || !formData.name || !formData.pin}
                  style={{flex:1,padding:'0.8rem',background:'#2a5298',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontWeight:'600'}}
                >
                  {isCreating ? 'Creando...' : 'Crear'}
                </button>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  disabled={isCreating}
                  style={{flex:1,padding:'0.8rem',background:'#6c757d',color:'white',border:'none',borderRadius:'4px',cursor:'pointer'}}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
